import React, { useState, useEffect } from 'react'
import querystring from 'query-string'
import io from 'socket.io-client'
import './Chat.css'
import InfoBar from '../InfoBar/InfoBar.js'
import Input from '../Input/Input.js'
import Messages from '../Messages/Messages.js'
import TextContainer from '../TextContainer/TextContainer.js'
let socket

const Chat = ({location}) => {
	const [name,setName] = useState('')
	const [room,setRoom] = useState('')
	const [users, setUsers] = useState([])
	const [message,setMessage] = useState('')
	const [messages,setMessages] = useState([])
	const ENDPOINT = 'https://react-online-chat-application.herokuapp.com/'
	
	useEffect(() => {
		const { name , room } = querystring.parse(location.search)
		
		socket = io(ENDPOINT)
		setName(name)
		setRoom(room)
		
		socket.emit('join' , {name,room} , () => {
		})
		
		return() => {
			socket.emit('disconnect')
			socket.off()
		}
	}, [ENDPOINT, location.search])
	useEffect(() => {
		socket.on('message' , (message) => {
			setMessages(messages => [...messages, message])
			})
		socket.on('roomData' , ({users}) => {
			setUsers(users)
		})
		
},[])
	
	const sendMessage = (event) => {
		event.preventDefault()
		if(message){ 
			socket.emit('sendMessage',message , () => setMessage(''))
		}
	}
	console.log(message , messages)
	return(
		<div className='outerContainer'>
			<div className='container'>
				<InfoBar room={room}/>
				<Messages messages={messages} name={name}/>
				<Input message={message} sendMessage={sendMessage} setMessage={setMessage}/>
			</div>
			<TextContainer users={users}/>
		</div>
	)
}

export default Chat